
export async function glideVendorInit() {
    const elements = document.querySelectorAll('.glide--vendor');
    if (elements.length) {
        let {default: Glide, Breakpoints, Controls} = await import('@glidejs/glide/dist/glide.modular.esm');
        elements.forEach(element => {
            new Glide(element, {
                // type: 'carousel',
                gap: '14px',
                perView: 4,
                bound: true,
                breakpoints: {
                    576: {
                        perView: 1,
                        peek: false
                    },
                    768: {
                        perView: 2,
                        peek: false
                    },
                    1460: {
                        perView: 3,
                        peek: false
                    }
                }
            }).mount({Controls, Breakpoints});
        });
    }
}